<template>
    <div>

        <TextBanner>
            <p>Nach zehn WM-Spielen – inklusive Finale – soll das Lusail-Stadion weiter genutzt werden.</p>
            <p>Eine Art Mehrzweck-Gemeinschaftszentrum ist geplant. Mit Cafés, Geschäften und Sportanlagen.</p>

        </TextBanner>


        <!-- Fallback -->
        <Fallback>
            <picture>
                <source media="(orientation: portrait)" srcset="../assets/img/fallback/fallback_P.jpg">
                <source media="(orientation: landscape)" srcset="../assets/img/fallback/fallback_L.jpg">
                <!-- The img element is required as the last child tag of the picture declaration block. The img element is used to provide backward compatibility for browsers that do not support the picture element, or if none of the source tags matched. -->
                <img src="../assets/img/fallback/fallback.jpg" alt="">
            </picture>
            <div class="hotspot" v-on:click="infobox('TolleInfoBox')"></div>
        </Fallback>


    </div>
</template>

<script>
    export default {
        name: 'infobox',
        babylonState: {
            camera: {
                position: [-1,.86,10],
                target:[0,-4,0],
                betaLimits: [0.01,1.5],
                animationSpeed: 2,
                radiusLimits: [10.35, 22], // minCamRadius, maxCamRadius
                fov: 1.8,
                clipping: [7, 10000.0],
                useAutoRotationBehavior: true,
                idleRotationSpeed: 0.1,
                
            

            },
            
            lusail:{
                Spielfeld_bake: {
                    visible: false,
                        Netz_Tor:{
                            visible: false,
                        },
                        Spanner_Tor:{
                            visible: false
                        },
                        Torgestell_2:{
                            visible: false
                        },
                        Fahnen_bake:{
                            visible: false,
                        },
                },
            },

           
        },
        babylonReady: function () {

            this.$babylonController.goToAnimation("anim_boden", 0);
            this.$babylonController.goToAnimation("anim_verlauf", 0);
            this.$babylonController.goToAnimation("anim_wanne", 0);
            this.$babylonController.goToAnimation("anim_19Grad", 0);
            this.$babylonController.goToAnimation("anim_23Grad", 0);


        },
    }
</script>

<style scoped lang="scss">

    .fallback-container .hotspot {

        left: 65vw;
        top: 40vh;

        @media (orientation: landscape) {
            left: 60vw;
            top: 35vh;
            transform: scale(0.75);
        }
    }


</style>
